import { css, keyframes } from 'styled-components';

import { transitionTimingFunction } from 'ggApp/utils/mixins';

export const ANIMATION_DURATION_IN_MS = 300;

const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

export const FadeInAnimation = css`
    animation-name: ${fadeIn};
    animation-duration: ${ANIMATION_DURATION_IN_MS}ms;
    animation-timing-function: ${transitionTimingFunction('in')};
`;
